import Cookies from 'universal-cookie';
const WarehouseClient = require('../vendor/client/WarehouseClinet').WarehouseClient;
const cookies = new Cookies();

export default new WarehouseClient({sessionKey: cookies.get('kjd_session')});